import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Link from 'next/link';
import React, { useCallback, useMemo } from 'react';
import { CircularProgress } from '@mui/material';
import navConfig from '@/config/navigation';
import ClientOnly from '@/components/ClientOnly';
import { ButtonV2 as Button } from '@/components/Button';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var GoogleLogo = function GoogleLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_5011_10365)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M13.16 7.14584C13.16 6.69084 13.1192 6.25334 13.0433 5.83334H7V8.31543H10.4533C10.3046 9.11751 9.8525 9.79709 9.17292 10.2521V11.8621H11.2467C12.46 10.745 13.16 9.10001 13.16 7.14584Z",
        fill: "#4285F4"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.00004 13.4167C8.73254 13.4167 10.185 12.8421 11.2467 11.8621L9.17295 10.2521C8.59837 10.6371 7.86337 10.8646 7.00004 10.8646C5.32879 10.8646 3.9142 9.73584 3.40962 8.21918H1.26587V9.88168C2.3217 11.9788 4.4917 13.4167 7.00004 13.4167Z",
        fill: "#34A853"
      }), /*#__PURE__*/_jsx("path", {
        d: "M3.40962 8.21918C3.28129 7.83418 3.20837 7.42293 3.20837 7.00001C3.20837 6.5771 3.28129 6.16585 3.40962 5.78085V4.11835H1.26587C0.831291 4.9846 0.583374 5.9646 0.583374 7.00001C0.583374 8.03543 0.831291 9.01543 1.26587 9.88168L3.40962 8.21918Z",
        fill: "#FBBC05"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.00004 3.13543C7.94212 3.13543 8.78795 3.45918 9.45295 4.09501L11.2934 2.25459C10.1821 1.21918 8.72962 0.583344 7.00004 0.583344C4.4917 0.583344 2.3217 2.02126 1.26587 4.11834L3.40962 5.78084C3.9142 4.26418 5.32879 3.13543 7.00004 3.13543Z",
        fill: "#EA4335"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_5011_10365",
        children: /*#__PURE__*/_jsx("rect", {
          width: "14",
          height: "14",
          fill: "white"
        })
      })
    })]
  }));
};

GoogleLogo.defaultProps = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const ButtonAuthWithGoogle = _ref => {
  let {
    variant,
    helperText,
    text,
    error,
    requestSignUp,
    loading,
    disabled,
    onClick = () => null
  } = _ref;
  const handleOnClick = useCallback(evt => {
    evt.preventDefault();
    evt.stopPropagation();
    onClick();
  }, [onClick]);
  const signUpUrl = useMemo(() => {
    const redirect = false ? '' : encodeURIComponent(window.location.pathname);
    return `${navConfig.signUpPage}${redirect ? '?redirect=' : ''}${redirect}`;
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Button, {
      type: "button",
      variant: "pill",
      className: "w-full",
      disabled: loading || disabled,
      leftIcon: loading ? /*#__PURE__*/_jsx(CircularProgress, {
        size: 16,
        color: "inherit"
      }) : /*#__PURE__*/_jsx(GoogleLogo, {
        className: "size-4"
      }),
      onClick: handleOnClick,
      children: text ?? getButtonText(variant)
    }), Boolean(helperText) && /*#__PURE__*/_jsx("div", {
      className: styles.text,
      children: helperText
    }), requestSignUp && /*#__PURE__*/_jsx(ClientOnly, {
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.text,
        children: [/*#__PURE__*/_jsx(Link, {
          href: signUpUrl,
          children: "Sign up for a free account"
        }), " to connect Google Drive."]
      })
    }), (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/_jsx("div", {
      className: "p-2 mt-2 text-center text-red-500 border border-red-600 border-dashed rounded",
      children: /*#__PURE__*/_jsx("span", {
        children: error.message
      })
    })]
  });
};

function getButtonText(variant) {
  return `Sign ${variant === 'signin' ? 'in' : 'up'} with Google`;
}

export default ButtonAuthWithGoogle;